export default "__VITE_ASSET__CB9uHaqe__"